module.exports = __webpack_public_path__ + "static/img/audio.d8107309.png";